import { useState, useCallback } from "react";

import { rotateBase64Image } from "../utils/Base64Utils";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const CustomImageViewer = ({ images, onVin }) => {
  const [index, setIndex] = useState(-1);
  const [rotatedImages, setRotatedImages] = useState({}); // Store rotated base64 for each image

  const rotateLeft = useCallback(async () => {
    console.log("CustomImageViewer rotateLeft", index);
    if (index >= 0) {
      const originalImage = images[index];
      const currentRotated = rotatedImages[index] || originalImage;

      const rotatedBase64 = await rotateBase64Image(currentRotated, -90);

      setRotatedImages((prev) => ({
        ...prev,
        [index]: rotatedBase64,
      }));
    }
  }, [index, images, rotatedImages]);

  const rotateRight = useCallback(async () => {
    console.log("CustomImageViewer rotateRight", index);
    if (index >= 0) {
      const originalImage = images[index];
      const currentRotated = rotatedImages[index] || originalImage;

      const rotatedBase64 = await rotateBase64Image(currentRotated, -90);

      setRotatedImages((prev) => ({
        ...prev,
        [index]: rotatedBase64,
      }));
    }
  }, [index, images, rotatedImages]);

  const readVin = () => {
    console.log("CustomImageViewer readVin", index);
    onVin(index);
  };

  // Get the current image source (rotated or original)
  const getImageSrc = useCallback(
    (i) => {
      return rotatedImages[i] || images[i];
    },
    [rotatedImages, images]
  );

  if (!images?.length) {
    return <></>;
  }

  const slides = images.map((_, i) => ({
    src: getImageSrc(i),
  }));

  return (
    <div className="d-flex flex-wrap gap-2">
      {images.map((base64, i) => (
        <div
          key={i}
          style={{
            width: 120,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={getImageSrc(i)}
            alt={`${i}`}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              cursor: "pointer",
              objectFit: "contain",
            }}
            onClick={() => setIndex(i)}
          />
        </div>
      ))}
      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        toolbar={{
          buttons: [
            <button
              key="read-vin"
              type="button"
              className="yarl__button"
              onClick={readVin}
              title="Wykryj VIN"
            >
              VIN
            </button>,
            <button
              key="rotate-left"
              type="button"
              className="yarl__button"
              onClick={rotateLeft}
              title="Obróć w lewo"
            >
              ↺
            </button>,
            <button
              key="rotate-right"
              type="button"
              className="yarl__button"
              onClick={rotateRight}
              title="Obróć w prawo"
            >
              ↻
            </button>,
            "close",
          ],
        }}
        slides={slides}
      />
    </div>
  );
};

export default CustomImageViewer;
